import { Link } from "react-router-dom";
import "../css/about.css";

const values = [
  {
    number: "01",
    title: "Proof before print",
    body: "Every job gets checked before it reaches the press. We care about alignment, colour, scale and the small details that separate a good print from a great one.",
  },
  {
    number: "02",
    title: "The right stock",
    body: "Paper changes everything. We select stock based on the purpose of the job, the finish you want and how the final piece should feel in your hands.",
  },
  {
    number: "03",
    title: "Straightforward work",
    body: "Clear specifications, clear pricing and clear communication. No unnecessary complexity between your idea and the finished print.",
  },
];

export default function About() {
  return (
    <main className="about">

      {/* =================================
          HERO
      ================================= */}

      <section className="about-hero">
        <div className="wrap">

          <div className="about-hero-top">
            <span className="eyebrow">
              <span className="eyebrow-dot" />
              About IGC
            </span>

            <span className="about-index">
              IGC / 02
            </span>
          </div>

          <h1 className="about-hero-title">
            We believe good
            <br />
            <span>printing should feel good.</span>
          </h1>

          <div className="about-hero-bottom">
            <p>
              IGC Print Press is a family-owned print studio built
              around careful production, honest service and work
              that looks as good in your hands as it did on screen.
            </p>

            <span className="about-scroll">
              ↓ Scroll to explore
            </span>
          </div>

        </div>
      </section>


      {/* =================================
          STORY
      ================================= */}

      <section className="about-story-section">
        <div className="wrap">

          <div className="about-story-grid">

            <div className="about-story-label">
              <span>01</span>
              Our story
            </div>

            <div className="about-story-content">

              <div className="about-story-heading">
                <h2>
                  From a small press
                  <br />
                  to a modern print studio.
                </h2>
              </div>

              <div className="about-story-copy">

                <p>
                  Founded in 2018, IGC Print Press started with a
                  simple idea: make professional printing more
                  dependable for businesses.
                </p>

                <p>
                  What began as a small operation has grown into
                  a production studio serving businesses, creatives
                  and organisations across Rivers State and beyond.
                </p>

                <p>
                  We combine traditional pressroom knowledge with
                  modern digital workflows, giving every project the
                  attention it deserves — whether it is a handful
                  of business cards or a large production run.
                </p>

              </div>

            </div>

          </div>


          {/* =================================
              VISUAL
          ================================= */}

          <div className="about-visual">

            <div className="about-visual-grid" />

            <div className="about-visual-mark">
              IGC
            </div>

            <div className="about-visual-copy">
              <span>PRINT / 001</span>
              <strong>EST. 2018</strong>
            </div>

            <div className="about-paper about-paper-back" />

            <div className="about-paper about-paper-middle" />

            <div className="about-paper about-paper-main">

              <span className="paper-corner">
                IGC / PRINT
              </span>

              <div className="paper-title">
                MADE
                <br />
                TO
                <br />
                LAST.
              </div>

              <div className="paper-line" />

              <div className="paper-footer">
                QUALITY PRINTING
              </div>

            </div>

          </div>

        </div>
      </section>


      {/* =================================
          VALUES
      ================================= */}

      <section className="about-values">

        <div className="wrap">

          <div className="about-values-header">

            <div className="about-section-label">
              <span>02</span>
              How we work
            </div>

            <div>

              <h2>
                The standard is
                <br />
                in the details.
              </h2>

              <p>
                Printing is physical. That means the little things
                matter — the stock, the cut, the colour, the finish
                and what happens before the machine ever starts.
              </p>

            </div>

          </div>


          <div className="values-list">

            {values.map((value) => (
              <article
                className="about-value"
                key={value.number}
              >

                <span className="about-value-number">
                  {value.number}
                </span>

                <h3>
                  {value.title}
                </h3>

                <p>
                  {value.body}
                </p>

                <span className="about-value-arrow">
                  ↗
                </span>

              </article>
            ))}

          </div>

        </div>

      </section>


      {/* =================================
          CLOSING CTA
      ================================= */}

      <section className="about-closing">

        <div className="wrap">

          <div className="about-closing-inner">

            <span className="eyebrow">
              <span className="eyebrow-dot" />
              Let's make something
            </span>

            <h2>
              Your idea deserves
              <br />
              <span>a physical form.</span>
            </h2>

            <Link
              to="/quote"
              className="about-closing-link"
            >
              Start a project
              <span>↗</span>
            </Link>

          </div>

        </div>

      </section>

    </main>
  );
}